import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";

async function selectComputerRoom(search, pageable) {
    console.log(">> 전산실 출입대장 List 조회")
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;


    try {
        return await needAuth.post(`/computerroom?`+pageStr, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}


async function getComputerRoom(id) {
    return await needAuth.get('/computerroom/'+id);
}

const getServiceApply = async (id) => {
    try {
        return await needAuth.get(`/serviceApply/${id}`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}
// async function createAsset(data) {
//     console.log(">>> api : 전산신 출입대장 등록")
//     const formData = new FormData();
//
//     formData.append(
//         "computerRoomRequestDto",
//         new Blob([JSON.stringify(data)], { type: "application/json" })
//     );
//     try{
//         return  await needAuth.post(
//             '/computerroom/create',
//             formData,
//             {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//             }
//         );
//     }catch (error){
//         return error;
//     }
// }

async function createComputerRoom(data) {

        console.log(">>> api : 전산실 출입대장 등록");
    try {
        return  await needAuth.post('/computerroom/create', data);
        } catch (error) {
            if (error instanceof AxiosError) {
                console.log(error.response)
                const status = error.response.status;
                const data = error.response.data;
                return {status, data}
            }
        }

}


async function checkOutComputerRoom(id, value, time) {
    try{
        console.log(">>> api : 전산실 퇴실하기");

        return  await needAuth.put(`/computerroom/${id}/checkout`,
            {id: id,
                  phoneNumber:value,
                  checkOutAt:time
            });
    }catch (error){
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}


async function removeComputerRooms(ids) {
    return await needAuth.put('/computerroom/delete', ids);
}

async function getCurrentApprovalProcess() {
    try {
        console.log(">>> api : 현재 결재라인 설정 조회");
        return await needAuth.get('/computerroom/approval-process');
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response?.status;
            const data = error.response?.data;
            return {status, data};
        }
        throw error;
    }
}

async function updateComputerRoomApprovalProcess(approvalProcessId) {
    try {
        console.log(">>> api : 결재라인 설정 업데이트");
        return await needAuth.post('/computerroom/approval-process', {
            approvalProcessId: approvalProcessId
        });
    } catch (error) {
        // 에러를 그대로 throw해서 호출하는 곳에서 처리하도록
        throw error;
    }
}


const updateServiceApply = async (data) => {
    try {
        return await needAuth.put(`/serviceApply`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const deleteServiceApply = async (id) => {
    try {
        return await needAuth.put(`/serviceApply/${id}`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}


export {selectComputerRoom, getComputerRoom,createComputerRoom, checkOutComputerRoom,removeComputerRooms, getCurrentApprovalProcess, updateComputerRoomApprovalProcess}

